// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"45d119b3","455":"2f4c2378","488":"8a2a81ae","977":"273c4ba9"}[chunkId] + ".chunk.js";
};